import { ActionTree } from 'vuex';

import { Item } from '@/models';
import { CSIItemService } from '@/services/csi-item-service';

const CSIService = new CSIItemService();

export const actions: ActionTree<any, any> = {
  fetchCsiItems: (_, params: URLSearchParams) =>
    CSIService.fetchCsiItems(params).then((items: Item[]) => {
      return items;
    }),

  fetchCsiItem: (_, payload: { id: number; params?: any }) =>
    CSIService.fetchCsiItem(payload.id, payload.params).then((item: Item) => {
      return item;
    })
};
